import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import Card from "../../components/card/Card";
import ButtonContainer from "../../components/buttonContainer";
import InputFields from "../../components/InputFields";
import SelectFields from "../../components/SelectFields";
import pharmacy from '../../assets/pharmacy.png'
import './pharmacy.scss'
import ActionButton from "../../components/actionButton";
import { ProfilePhoto } from "../../components/profilePhoto/profilePhoto";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createPharmacy, updatePharmacy } from "../../store/actions/pharmacy";
import { setDataObject } from "../../utils/Utils";
import { createRecord, updateRecord } from "../../store/reducers/pharmacy-slice";
import SaveButton from "../../components/saveButton/saveButton";
const PharmacyForm = (props) => {
    const { data, setOpen } = props
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company)
    const { user } = useSelector(state => state.auth)
    const [isLoading, setIsLoading] = useState(false)

    const defaultValues = useForm({
        defaultValues: {
            PharmacyName: "",
            EmailAddress: "",
            Website: '',
            Phone: "",
            CompanyID: ""
        },
    });

    useEffect(() => {
        if (data?.id) {
            reset({
                PharmacyName: data.pharmacyName || "",
                EmailAddress: data.emailAddress || "",
                Website: data.website || "",
                Phone: data.phone || "",
                CompanyID: data.company_ID || "",
            });
        }
    }, []);

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        getValues,
        formState: { errors },
    } = defaultValues;

    const submit = () => {
        setIsLoading(true)
        let saveObj = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "INSERTPHARMACY",
            "data": setDataObject({ ...getValues(), "CreatedBy": user?.userId }),
            "debug": null,
            "token": null
        }

        if (user?.userType != 1) {
            saveObj['data']['CompanyID'] = user?.businessId
        }
        if (data?.id) {
            let updateObj = { ...saveObj }
            updateObj['data'] = { ...saveObj['data'], 'ID': data.id, 'EditBy': user?.userId, ISUPDATE: 1 }
            updateObj['msgType'] = 'UPDATEPHARMACY'
            const sentObj = updateObj.data
            const saveObject = {
                id: sentObj.ID,
                pharmacyName: sentObj.PharmacyName,
                emailAddress: sentObj.EmailAddress,
                website: sentObj.Website,
                phone: sentObj.Phone,
                company_ID: sentObj.CompanyID,
                createdOn: data.createdOn,
                editOn: data.editOn,
                isActive: data.isActive,
            }
            dispatch(updatePharmacy(updateObj)).then(res => {
                setIsLoading(false)
                dispatch(updateRecord(saveObject))
                setOpen(false)
            })
        } else {
            dispatch(createPharmacy(saveObj)).then(res => {
                setIsLoading(false)
                let obj = res.payload
                obj['company_ID'] = obj.companyId
                delete obj.companyId
                dispatch(createRecord(obj))
                setOpen(false)
            })
        }
    }


    return <Card style={{ flex: 1, }}>
        <Box className="pharmacyFormContainer">
            <form>
                <Typography variant='h3' >Profile picture upload</Typography>
                <Box className='pharmacyProfileContainer'>
                    <ProfilePhoto image={pharmacy} />
                    <ActionButton label={'Upload pharmacy Photo'} />
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <Typography variant='h3' >Pharmacy Information</Typography>
                    </Grid>
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="PharmacyName"
                            type="text"
                            label="pharmacy Name"
                            control={control}
                            rules={{
                                required: "pharmacy Name is required",
                            }}
                            error={errors?.PharmacyName}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="EmailAddress"
                            type="text"
                            label="Email Address"
                            control={control}
                            rules={{
                                required: "Email Address is required",
                            }}
                            error={errors?.EmailAddress}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="Website"
                            type="text"
                            label="Website"
                            control={control}
                            rules={{
                                required: "Website is required",
                            }}
                            error={errors?.Website}
                        />
                    </Grid>
                    {user?.userType == 1 && <Grid item xs={6} >
                        <SelectFields
                            fieldName="CompanyID"
                            label="Company"
                            control={control}
                            options={company.map(({ companyName, id }) => {
                                return { label: companyName, value: id };
                            })}

                            rules={{
                                required: "Company is required",
                            }}
                            error={errors?.CompanyID}
                        />
                    </Grid>
                    }
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="Phone"
                            type="text"
                            label="Phone"
                            control={control}
                            rules={{
                                required: "Phone is required",
                            }}
                            error={errors?.Phone}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <ButtonContainer isSingle>
                            <SaveButton isLoading={isLoading} onClick={handleSubmit(submit)} title={'Save'} />
                        </ButtonContainer>
                    </Grid>
                </Grid>
            </form>
        </Box>
    </Card>
};

export default PharmacyForm;
